import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {

  constructor(
    private router: Router
  ) {
  }

  ngOnInit(): any {}

  goPlaces(page, anchor): any {
    this.router.navigate([page], { fragment: anchor });
  }
}
